import { Col, Divider, Row } from "antd";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetProgramApplicationDetail } from "../../../apis/actions/programs.actions";
import moment from "moment";
import MoyasarForm from "../../../components/Moyasar/MoyasarForm";
import { setMobile, setProgramId } from "../../../apis/slices/moyasarSlice";
import Loader from "../../../biblio/Loader/Loader";

const PayProgramApplication = () => {
  const { access_token } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { programApplication } = useSelector(
    (state: RootState) => state?.programs
  );
  const [result, setResultat] = useState<any>(null);
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);

  useEffect(() => {
    dispatch(toGetProgramApplicationDetail(access_token));
  }, [dispatch, access_token]);

  const toFormatData = () => {
    const formattedData = [
      { title: "البرنامج :", value: programApplication?.data?.program_name },
      { title: " رقم الترشح :", value: programApplication?.data?.name },
      {
        title: " قيمة الترشح :",
        value: programApplication?.data?.registration_fees + " ريال",
      },
      {
        title: " تاريخ بداية البرنامج :",
        value: moment(programApplication?.data?.start_date)
          .locale("en")
          .format("YYYY/MM/DD"),
      },
      {
        title: " تاريخ نهاية البرنامج :",
        value: moment(programApplication?.data?.end_date)
          .locale("en")
          .format("YYYY/MM/DD"),
      },
      {
        title: "حالة الدفع :",
        value: programApplication?.data?.is_paid ? "مدفوع" : "غير مدفوع",
      },
    ];
    setResultat(formattedData);
  };
  useEffect(() => {
    toFormatData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programApplication]);

  const openMoyasar = () => {
    setDisplayMoyasar(true);
    dispatch(setMobile(programApplication?.data?.mobile));
    dispatch(setProgramId(programApplication?.data?.id));
  };
  if (programApplication?.loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <div style={{ backgroundColor: "#F2F4F4", minHeight: "100vh" }}>
        <Row justify={"center"} style={{ width: "100%", paddingTop: "4rem" }}>
          <Col xxl={4} xl={4} md={2} lg={2} sm={1} xs={1} />
          <Col xxl={8} xl={8} lg={13} md={13} sm={20} xs={20}>
            <div style={{ borderRadius: "40px" }}>
              <div className="takaful--card-moyasser-header">
                <span>تفاصيل البرنامج </span>
              </div>
              <div className="takaful--card-moyasser-body">
                {result?.map((el: any, index: number) => (
                  <>
                    <Row className="takaful--card-moyasser-body-item">
                      <Col span={16}>
                        <p
                          className={
                            index === 0
                              ? "takaful--card-moyasser-body-item-title"
                              : "takaful--card-moyasser-body-item-title takaful--text-color"
                          }
                        >
                          {el.title}
                        </p>
                      </Col>
                      <Col span={8}>
                        <span
                          className={`takaful--card-moyasser-body-item-value ${
                            el?.value?.includes("ريال")
                              ? "icon-saudi_riyal"
                              : ""
                          }`}
                        >
                          {el?.value?.replace("ريال", "").trim()}
                        </span>
                      </Col>
                    </Row>
                    {index === 0 && (
                      <Row>
                        <Col span={21}>
                          <Divider
                            variant="dashed"
                            dashed
                            className="takaful--card-moyasser-divider"
                          />
                        </Col>
                      </Row>
                    )}
                  </>
                ))}

                <Divider className="takaful--moyasar-divider-btn" />

                <Row align={"middle"} justify={"center"}>
                  <Col span={22}>
                    {!programApplication?.data?.is_paid && (
                      <PrimaryButton
                        style={{
                          marginBottom: "0.5rem",
                          width: "100%",
                        }}
                        title="سداد "
                        onClick={() => openMoyasar()}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xxl={4} xl={4} md={2} lg={2} sm={1} xs={1} />
        </Row>
      </div>

      <MoyasarForm
        amount={programApplication?.data?.registration_fees}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => setDisplayMoyasar(false)}
      />
    </>
  );
};

export default PayProgramApplication;
